<template>
    <Autocomplete
      root-class="simplesearch"
      :group-options="groupOptions"
      :no-matches-text="noMatchesText"
      :placeholder="placeholder"
      :value="searchValue"
      :items="internalItems"
      :get-label="getLabel"
      :get-value="getValue"
      :keep-open="false"
      @focus="focus"
      @change="autocompleteDebounce"
      @enter="enterInput"
      @item-selected="itemSelected"
      @item-clicked="itemClicked"
    >
      <a class="input-icon" slot="input-icon" @click="search"> <i class="fa fa-search text-lead"></i></a>
      <template slot-scope="{ item }">
        <div class="autocomplete-item" v-html="getLabel(item)"></div>
        <div class="autocomplete-id" v-if="item.id"><span v-html="getLabel(item.id)"></span><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="external-link-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon svg-inline--fa fa-external-link-alt fa-w-16"><path fill="currentColor" d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z" class=""></path></svg></div>
      </template>
    </Autocomplete>
</template>

<script>
  import Autocomplete from 'lei-shared/autocomplete/Autocomplete.vue'
  import SearchMixin from 'lei-shared/mixins/search-mixin'

  const LEISEARCH_API_BASE_URL = 'https://api.gleif.org/api/v1/'

  const getData = (endpoint, q) => {
    var escapedQ = encodeURIComponent(q)
    return fetch(`${LEISEARCH_API_BASE_URL}${endpoint}?q=${escapedQ}&field=fulltext`)
      .then(response => response.json())
      .then(data => data)
      .catch(error => console.error(new Error(error)))
  }
  function replaceAll (str, encodingChars) {
   return encodingChars.reduce((strAccumulator, current) => {
            var search = current[0].toString()
            var replacer = current[1].toString()
      return strAccumulator.replace(new RegExp(search, 'g'), replacer)
   }, str)
  }
  export default {
    name: 'SimpleSearch',
    components: {
      Autocomplete
    },
    mixins: [SearchMixin], // mixin for for getting rid of duplicate code
    data () {
      return {
        placeholder: 'LEI Search',
        noMatchesText: 'No matches ...',
        groupOptions: true,
        searchValue: ''
      }
    },
    methods: {
      // autocomplete method for correct work of the mixin (mixin use "autocomplete")
      autocomplete: ({endpoint = 'autocompletions', q}) => getData(endpoint, q),
      // "setInputValue" method for correct work of the mixin (mixin use "setInputValue")
      setInputValue (val) {
        this.searchValue = val
      },
      itemSelected (item) {
        this.searchValue = item.value
        this.search(item)
        // console.log('itemSelected', item)
      },
      itemClicked (item) {
        // console.log('itemClicked', item)
      },
      enterInput (value) {
        this.search(this.searchValue)
        // console.log('enterInput', value)
      },
      search (value) {
        // encoding to work proper with LEI Search 2.0 (https://gitlab.com/code-care/lei-search-new/issues/194#note_263078683)
        // escaping regex-characters to work proper with regex
        var encodingChars = [['\\!', '{ex}'], ['\\*', '{ast}'], ['\'', '{ap}'], ['\\(', '{prl}'], ['\\)', '{prr}'], [';', '{sc}'], [':', '{c}'], ['\\@', '{at}'], ['\\&', '{amp}'], ['=', '{eq}'], ['\\+', '{pl}'], ['\\$', '{dol}'], [',', '{com}'], ['/', '{sl}'], ['\\?', '{q}'], ['#', '{h}'], ['\\[', '{brl}'], ['\\]', '{brr}'], ['%', '{ps}']]
        var replacedSearchValue = replaceAll(this.searchValue, encodingChars);
        // value.id = LEI
        (value.id == null) ? window.location.href = `https://search.gleif.org/#/search/simpleSearch=${value.value || encodeURI(replacedSearchValue)}` : window.location.href = `https://search.gleif.org/#/record/${value.id}`
      }
    }
  }
</script>

<style lang="stylus">
  @import '../assets/variables.styl'
  .simplesearch
    position relative
    width 300px

    &.opened
      .autocomplete-input-group
        .autocomplete-input
          border-color $primary-color-light-1

        .input-icon
          background-color $default-color-light-1
          color $primary-color-light-1

    .autocomplete
    .autocomplete-input-group
      width 100%

      .input-icon
        position absolute
        left 100%
        top 3px
        margin-left -37px
        height "calc(%s - 6px)" % $input-sm
        width "calc(%s - 6px)" % $input-sm
        align-items center
        justify-content center
        border-radius 50%
        background-color $default-color-light-2
        color $default-color-middle

        .icon
          font-weight bold

        &:hover
          background-color $default-color-light-1
          color $primary-color

      .autocomplete-input
        outline none
        height $input-sm
        background-color $white-color
        border 1px solid $default-color-light-1
        width 100%
        font-size .75rem
        padding 10px
        box-shadow none
        border-radius "calc(%s / 2)" % $input-sm

    .autocomplete-list
      height fit-content
      border 1px solid $default-color-light-2
      background-color $white-color
      position absolute
      bottom -5px
      transform translateY(100%)
      text-align left
      width 100%
      box-shadow $box-shadow-light
      overflow-y auto
      color $default-color-bold

      .autocomplete-list-group-title
        background-color $default-color-light-2
        font-weight 600

      .autocomplete-list-item
        font-weight 600

        &:hover, &.autocomplete-item-active
          background-color $primary-color-light-3

      .autocomplete-list-item, .autocomplete-list-group-title
        cursor pointer
        align-items center
        padding 10px 12px
        font-size .75rem

        .autocomplete-item
          white-space pre
          align-items center

        .autocomplete-id
          font-size:9px
          font-weight: 400;
          color: #a8a8a8

          svg
            width: 9px
            margin-left: 4px
</style>



// WEBPACK FOOTER //
// src/components/SimpleSearch.vue